import React from 'react';
import { motion } from 'framer-motion';
import { Section, fadeInUp, staggerContainer } from './ui/Section';
import { BookOpen, Users, Crown } from 'lucide-react';
export function UniqueMechanism() {
  return <Section darker id="mechanism" data-id="element-104">
      <motion.div initial="hidden" whileInView="visible" viewport={{
      once: true,
      margin: '-100px'
    }} variants={staggerContainer} data-id="element-105">
        <motion.div variants={fadeInUp} className="text-center mb-16" data-id="element-106">
          <span className="text-gold-light uppercase tracking-widest text-sm font-bold mb-2 block" data-id="element-107">
            El Mecanismo Único
          </span>
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-white mb-6" data-id="element-108">
            Este Paquete Combina <br data-id="element-109" />
            <span className="text-gold-gradient" data-id="element-110">Tres Elementos Clave</span>
          </h2>
          <p className="text-gray-400 max-w-2xl mx-auto" data-id="element-111">
            No es solo una faja. Es un sistema completo diseñado para garantizar
            tu satisfacción y resultados.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-112">
          {/* Card 1 */}
          <motion.div variants={fadeInUp} className="relative group" data-id="element-113">
            <div className="absolute inset-0 bg-gold-gradient opacity-0 group-hover:opacity-100 blur transition-opacity duration-500 rounded-2xl" data-id="element-114"></div>
            <div className="relative h-full bg-dark-800 p-8 rounded-2xl border border-gold-dark/30 hover:border-transparent transition-all duration-300 flex flex-col" data-id="element-115">
              <div className="w-14 h-14 bg-gold-dark/10 rounded-full flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300" data-id="element-116">
                <BookOpen className="w-7 h-7 text-gold-DEFAULT" data-id="element-117" />
              </div>
              <h3 className="text-2xl font-serif font-bold text-white mb-4" data-id="element-118">
                1. El eBook
              </h3>
              <p className="text-gray-400 leading-relaxed" data-id="element-119">
                Una guía digital descargable con toda la información sobre el
                uso, el ajuste, los cuidados y los trucos para sacarle el máximo
                provecho a tu faja.
              </p>
            </div>
          </motion.div>

          {/* Card 2 */}
          <motion.div variants={fadeInUp} className="relative group" data-id="element-120">
            <div className="absolute inset-0 bg-gold-gradient opacity-0 group-hover:opacity-100 blur transition-opacity duration-500 rounded-2xl" data-id="element-121"></div>
            <div className="relative h-full bg-dark-800 p-8 rounded-2xl border border-gold-dark/30 hover:border-transparent transition-all duration-300 flex flex-col" data-id="element-122">
              <div className="w-14 h-14 bg-gold-dark/10 rounded-full flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300" data-id="element-123">
                <Users className="w-7 h-7 text-gold-DEFAULT" data-id="element-124" />
              </div>
              <h3 className="text-2xl font-serif font-bold text-white mb-4" data-id="element-125">
                2. La Asesoría
              </h3>
              <p className="text-gray-400 leading-relaxed" data-id="element-126">
                Una sesión 1-a-1 donde resolverás todas tus dudas sobre la faja,
                la talla a elegir y el uso adecuado, para que tengas la
                seguridad de que estás haciéndolo bien.
              </p>
            </div>
          </motion.div>

          {/* Card 3 */}
          <motion.div variants={fadeInUp} className="relative group" data-id="element-127">
            <div className="absolute inset-0 bg-gold-gradient opacity-0 group-hover:opacity-100 blur transition-opacity duration-500 rounded-2xl" data-id="element-128"></div>
            <div className="relative h-full bg-dark-800 p-8 rounded-2xl border border-gold-dark/30 hover:border-transparent transition-all duration-300 flex flex-col" data-id="element-129">
              <div className="w-14 h-14 bg-gold-dark/10 rounded-full flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300" data-id="element-130">
                <Crown className="w-7 h-7 text-gold-DEFAULT" data-id="element-131" />
              </div>
              <h3 className="text-2xl font-serif font-bold text-white mb-4" data-id="element-132">
                3. La Faja Original
              </h3>
              <p className="text-gray-400 leading-relaxed" data-id="element-133">
                Auténtica, confeccionada en Colombia, diseñada para tallas 2XL a
                5XL, con un ajuste perfecto para mujeres plus size en EE.UU. Te
                la enviaremos hasta la puerta de tu casa sin costo adicional.
              </p>
            </div>
          </motion.div>
        </div>
      </motion.div>
    </Section>;
}